import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';

import { CarteraServiceProvider } from '../../providers/cartera-service/cartera-service';
/**
 * Generated class for the ConsolidadoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-consolidado',
  templateUrl: 'consolidado.html',
})
export class ConsolidadoPage {

  auxreporte:{desde:String, hasta:String };

  auxSemaforo:any =true;

  fechaDesde:Date= new Date();

  auxGenerar: Number =0;


  constructor(public navCtrl: NavController, public navParams: NavParams, 
    public carteraProvider: CarteraServiceProvider, public loadingCtrl: LoadingController) {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000;

    this.fechaDesde = new Date(Date.now() - tzoffset);
    this.fechaDesde.setDate( this.fechaDesde.getDate()-365 )
    this.auxreporte={desde: this.fechaDesde.toISOString(), hasta: (new Date(Date.now() - tzoffset)).toISOString() };

    console.log(this.auxreporte.desde);
    console.log(this.auxreporte.hasta);
  }

  ionViewDidLoad() {
    

    
  }
  generar(){
    this.auxGenerar=1;
    let loading = this.loadingCtrl.create({
      content: 'Cargando, espere por favor...'
    });
    loading.present();

    this.auxSemaforo=true;
    this.carteraProvider.getReporteConsolidado(1, this.auxreporte.desde ,this.auxreporte.hasta )
    .then(data=>{      
      this.auxSemaforo=false;  
      loading.dismiss();
    })
    .catch(error=>{
      console.log(error);
      loading.dismiss();
    })
  }
  generarMes()
  {
     this.auxGenerar=2;
    let loading = this.loadingCtrl.create({
      content: 'Cargando, espere por favor...'
    });
    loading.present();
    this.auxSemaforo=true;
    this.carteraProvider.getReporteConsolidadoMes(1, this.auxreporte.desde ,this.auxreporte.hasta )
    .then(data=>{      
      this.auxSemaforo=false;
      loading.dismiss();
    })
    .catch(error=>{
      console.log(error);
      loading.dismiss();
    }) 
  }
  abrirPDF()
  {
      if (this.auxGenerar>0)
      {
        if (this.auxGenerar==1)
          window.open(this.carteraProvider.serverServicios + "/consolidado.pdf", "_blank");  
        else
          window.open(this.carteraProvider.serverServicios + "/consolidadomes.pdf", "_blank");  
      }
  		
  }

}



// WEBPACK FOOTER //
// ./src/pages/consolidado/consolidado.ts